import { message, Select } from 'antd'
import { runInAction } from 'mobx'
import moment from 'moment'
import React from 'react'
import { api } from '../api'
import { getDescription, getError } from '../helpers/helpers'
import { vars } from './vars'

export function createStore() {
  return {
    ...vars,
    initialValue: {
      ...vars,
    },
    reset() {
      for (let key in vars) {
        this[key] = this.initialValue[key]
      }
    },
    getResourceTopic(id, onLoad, onError) {
      const url = id ? `/resource_guide/${id}/` : `/resource_guide/`

      api(url, {}, 'GET').then((data) => {
        if (data.errors) {
          onError && onError()
          return
        }
        runInAction(() => {
          this[id ? 'resourcesCurrentTopic' : 'resources'] = data

          if (!id) this.resourcesCurrentTopic = null

          if (id) {
            this.resourceFilteredTopics = data.rows
          } else {
            this.resourceFilteredTopics = null
          }

          onLoad && onLoad()
        })
      })
    },
    getResourceRegisterGuides() {
      const url = '/resources/guides_for_registration/'

      api(url, {}, 'GET').then((data) => {
        if (data.errors) return message.error(getError(data))
        runInAction(() => {
          this.registerGuides = data
        })
      })
    },
    getJurisdiction(id, onLoad, onError) {
      if (!id) {
        this.resourceFiltered = null
        this.resourcesTable = null

        return
      }

      const url = `/resource_by_jurisdiction/?jurisdiction=${id}`

      api(url, {}, 'GET').then((data) => {
        if (data.errors) {
          onError && onError()
          return
        }
        runInAction(() => {
          this.resourceFiltered = data.results
          this.resourcesTable = data.results
        })
        onLoad && onLoad(data.results)
      })
    },
    getResourceFilters() {
      api('/resource_guide/filters/', {}, 'GET').then((data) => {
        runInAction(() => {
          this.resourceFilters = data
          if (!this.company[0].is_resource_registration_passed)
            this.getCompany()
        })
      })
    },
    setFilteredResources(data) {
      this.resourceFiltered = data
    },
    getCurrentTariff() {
      const filtered = this.tariffInfo?.tariffs?.filter((item) => {
        return item.code === this.company?.[0]?.tariff
      })
      if (filtered?.length) return filtered[0]
      return null
    },
    setCurrentLegislative(legislative, isChange) {
      if (isChange) {
        const item = this.currentLegislative
        this.currentLegislative = { ...item, ...legislative }
      } else {
        this.currentLegislative = legislative
      }
    },
    setSingleValue(variable, value) {
      this[variable] = value
    },
    setToExistingMembers(member) {
      this.members = [...this.members, member]
    },
    setRegisterData(type, value) {
      this.registerData[type] = value
    },
    setAgreement() {
      this.agreement = !this.agreement
    },
    getMember(id) {
      const member = this.members.find((item) => item.id === id)

      return member && `${member.first_name} ${member.last_name}`
    },
    getTariffInfo() {
      api('/payments/tariffs/', {}, 'GET').then((data) => {
        if (!data.errors) {
          runInAction(() => {
            this.tariffInfo = data
            this.currentTariff = this.getCurrentTariff()
          })
        } else {
          message.error(getError(data))
        }
      })
    },
    loadMember(id) {
      api(`/members/${id}/`, {}, 'GET')
        .then((data) => {
          if (!data.errors) {
            runInAction(() => {
              this.member = data
            })
          }
        })
        .catch((err) => console.log(err))
    },
    getSearchableString(obj) {
      let string = ''
      const searchObj = obj

      for (let key in searchObj) {
        if (key === 'date_range') {
          if (obj.today_proximity) {
            const dateAfter = searchObj[key].split('±')[0]
            const dateBefore = searchObj[key].split('±')[1]
            string += `compliance_date_after=${moment(dateAfter).format(
              'YYYY-MM-DD'
            )}&compliance_date_before=${moment(dateBefore).format(
              'YYYY-MM-DD'
            )}`
          }
        } else {
          if (searchObj[key]) string += `${key}=${searchObj[key]}&`
        }
      }

      return string
    },
    loadLegislatives(obj) {
      const filteredObj = {}

      const notSearchParams = ['setTemporary', 'handleLoading', 'page_size']

      for (let key in obj) {
        if (!notSearchParams.includes(key)) {
          filteredObj[key] = obj[key]
        }
      }

      const getSearchableString = () => {
        let string = ''
        const searchObj = { ...filteredObj, ...this.searchableObject }
        for (let key in searchObj) {
          string += `&${key}=${searchObj[key]}`
        }

        return string
      }

      const status =
        this.legislativesStatus === 'actual'
          ? 'actual=actual'
          : `status=${this.legislativesStatus}`

      const getData = () =>
        api(
          `/legislative/?page_size=${
            obj?.page_size || 20
          }&${status}${getSearchableString()}`,
          {},
          'GET'
        )
          .then((data) => {
            if (!data.errors) {
              runInAction(() => {
                if (obj?.setTemporary) {
                  this.legislativesTemporary = data
                } else {
                  this.legislatives = data
                  this.legislativesArray = data.results
                }
              })
              obj?.handleLoading && obj.handleLoading()
            } else {
              runInAction(() => {
                this.searchableObject = null
              })
              obj.onError && obj.onError()
            }
          })
          .catch((err) => console.log(err))

      getData()
    },

    loadTasks(obj) {
      const filteredObj = {}

      const notSearchParams = ['setTemporary', 'handleLoading', 'page_size']

      for (let key in obj) {
        if (!notSearchParams.includes(key)) {
          filteredObj[key] = obj[key]
        }
      }

      const getSearchableString = () => {
        let string = ''
        const searchObj = { ...filteredObj, ...this.searchableObjectTasks }
        for (let key in searchObj) {
          string += `&${key}=${searchObj[key]}`
        }

        return string
      }

      api(
        `/tasks/?page_size=${obj?.page_size || 20}${getSearchableString()}`,
        {},
        'GET'
      ).then((data) => {
        if (!data.errors) {
          runInAction(() => {
            if (obj.setTemporary) {
              this.tasksTemporary = data
            } else {
              this.tasks = data
            }
          })
          obj?.handleLoading && obj?.handleLoading()
        }
      })
    },

    mutateLegislatives(id, data) {
      const index = this.legislatives.results.findIndex(
        (item) => item.id === id
      )

      const item = this.legislatives.results[index]

      let legislatives = this.legislatives.results

      legislatives[index] = { ...item, ...data }

      runInAction(() => {
        this.legislatives.results = legislatives
      })
    },
    setAddedMember(member, onAdded, onError, isResource) {
      const checkForRepeat = this.addedMembers.filter(
        (item) => item.email === member.email
      )

      const checkForRepeatExisting = this.members.filter(
        (item) => item.email === member.email
      )

      const isError = isResource
        ? checkForRepeat.length
        : checkForRepeat.length || checkForRepeatExisting.length

      if (isError) {
        onError && onError()
        return
      }

      this.addedMembers.unshift(member)

      onAdded && onAdded()
    },
    getAddedMember(id, existing) {
      return this[existing ? 'members' : 'addedMembers'].find(
        (item) => item.id === id
      )
    },
    modifyAddedMember(member, existing) {
      const index = this[existing ? 'members' : 'addedMembers'].findIndex(
        (item) => item.id === member.id
      )

      this[existing ? 'members' : 'addedMembers'][index] = member
    },
    deleteAddedMember(id, existing) {
      this[existing ? 'members' : 'addedMembers'] = this[
        existing ? 'members' : 'addedMembers'
      ].filter((item) => item.id !== id)
    },
    mergeMembers() {
      this.members = [...this.members, ...this.addedMembers]
      this.addedMembers = []
    },
    setComment(comment, reply, parentId) {
      if (reply) {
        this.comments.results
          .find((item) => item.id === parentId)
          .descendants.unshift(comment)
      } else {
        this.comments.results = [comment, ...this.comments.results]
      }
    },
    setDocument(document) {
      this.documents.results = [document, ...this.documents.results]
    },
    updateCompany(item) {
      const company = this.company[0]

      this.company[0] = { ...company, ...item }
    },
    getCompany(onLoaded) {
      api('/companies/', {}, 'GET').then((data) => {
        if (!data.errors) {
          onLoaded && onLoaded()
          this.company = data
        }
      })
    },
    getUser(onLoaded, member) {
      const url = member ? `/members/${this.company[0].owner}/` : `/users/`

      api(url, {}, 'GET').then((data) => {
        if (!data.errors) {
          this[member ? 'member' : 'user'] = data

          onLoaded && onLoaded()
        }
      })
    },
    loadSelect(type, onLoad, onlyPaidGuides = true) {
      const getVarToSet = (value, type) => {
        const varTypes = {
          jurisdictions:
            type === 'companyOptions'
              ? 'jurs'
              : type === 'memberOptions'
              ? 'jursMembers'
              : 'jursCurrentMember',
          topics:
            type === 'companyOptions'
              ? 'topics'
              : type === 'memberOptions'
              ? 'topicsMembers'
              : 'topicsCurrentMember',
          line_of_business:
            type === 'companyOptions'
              ? 'lineOfBusinesses'
              : type === 'memberOptions'
              ? 'lineOfBusinessesMembers'
              : 'lineOfBusinessesCurrentMember',
          result: type,
          resources_guides:
            type === 'companyOptions'
              ? 'resourceGuides'
              : type === 'memberOptions'
              ? 'resourceMembers'
              : 'resourceCurrentMember',
          resource_jurisdictions:
            type === 'companyOptions'
              ? 'resourceJurisdictions'
              : type === 'memberOptions'
              ? 'resourceJurisdictionsMembers'
              : 'resourceJurisdictionsCurrentMember',
        }

        return varTypes[value] ?? null
      }

      const setValue = (data, type) => {
        if (typeof data === 'object') {
          for (let key in data) {
            if (type === 'states' ? data.result : data[key].length) {
              const options = data[type === 'states' ? 'result' : key].map(
                (item) => item
              )

              runInAction(() => {
                this[getVarToSet(key, type) || key] = options
              })
            }
          }
        }
      }

      const selectType = {
        companyOptions: '/companies/company_options/',
        memberOptions: `/companies/member_options/?only_paid_guides=${onlyPaidGuides}`,
        currentMemberOptions: '/companies/current_member_options/',
        states: '/companies/states_options/',
      }

      api(selectType[type], {}, 'GET')
        .then((data) => {
          if (!data.errors) {
            setValue(data, type)
            onLoad && onLoad()
          } else {
            this[type] = []
          }
        })
        .catch((err) => console.log(err))
    },
    loadMembers(obj) {
      const getSearchableString = () => {
        let string = ''

        const searchObj = { ...this.searchableMembersObject }

        for (let key in searchObj) {
          string += `${key}=${searchObj[key]}&`
        }

        return string
      }

      const selectOption = (item, type) => (
        <Select.Option
          key={item.id}
          value={type === 'mention' ? item.username : item.id.toString()}
        >
          {item.first_name + ' ' + item.last_name}
        </Select.Option>
      )

      api(`/members/?${getSearchableString()}`, {}, 'GET').then((data) => {
        if (!data.errors) {
          const mentionMembers = data
            .filter((item) => item.have_access_to_tracking)
            .map((item) => selectOption(item, 'mention'))

          runInAction(() => {
            this.members = data
            if (!obj) {
              this.membersMentions = mentionMembers
            }
          })
        }
      })
    },
    loadComments(legislative, page, handleLoading) {
      api(
        `/legislative_comments/?legislative=${legislative}&page=${page}&page_size=5`,
        {},
        'GET'
      ).then((data) => {
        if (!data.errors) {
          runInAction(() => {
            this.comments = data
          })
          handleLoading && handleLoading()
        }
      })
    },
    loadDocuments(legislative, page) {
      api(
        `/legislative_file/?legislative=${legislative}&page=${page}`,
        {},
        'GET'
      ).then((data) => {
        if (!data.errors) {
          this.documents = data
        }
      })
    },
    deleteDocument(id, onDeleted) {
      api(`/legislative_file/${id}/`, {}, 'DELETE').then((data) => {
        if (!data.errors) {
          this.documents.results = this.documents.results?.filter(
            (item) => item.id !== id
          )
          onDeleted && onDeleted()
        }
      })
    },
    loadActivity(legislative, page, handleLoading) {
      api(
        `/legislative_activity/?legislative=${legislative}&page=${page}`,
        {},
        'GET'
      ).then((data) => {
        if (!data.errors) {
          this.activity = data
          handleLoading && handleLoading()
        }
      })
    },
    getBillingCards() {
      api('/payment_cards/', {}, 'GET').then((data) => {
        if (!data.errors) {
          runInAction(() => {
            this.billingCards = data.results
          })
        }
      })
    },
    getResourceTariffInfo(onLoad) {
      api('/resources/my-tariff/', {}, 'GET').then((data) => {
        if (!data.errors) {
          runInAction(() => {
            this.resourceTariffInfo = data
          })
          onLoad && onLoad()
        } else {
          message.error('Error while getting info about resource tariff')
        }
      })
    },
    getBills() {
      api('/pending_bills/', {}, 'GET').then((data) => {
        if (!data.errors) {
          runInAction(() => {
            this.bills = data.results
          })
        }
      })
    },
    getSelectedJurisdictions() {
      api('/resources/selected_jurisdictions/', {}, 'GET').then((data) => {
        if (data.errors) return message.error(getError(data))

        this.selectedJurisdictions = data.jurisdictions.map((item) => ({
          id: item,
          name: getDescription(this.jurs, item),
        }))
      })
    },

    setResourcePrevLink(arr) {
      this.resourcePrevLink = arr
    },

    setPrimaryCard(id) {
      api(`/payment_cards/${id}/set_is_primary/`, {}, 'POST').then((data) => {
        if (data.errors) return message.error(getError(data))

        message.success('Card set as primary')
      })
    },

    getLegislativeOptions() {
      api('/companies/legislative_options/', {}, 'GET').then((data) => {
        if (data.errors) return message.error(data)

        this.legislative_options = data
      })
    },
  }
}
